import { string } from 'yup';
import messages from './messages.js';

function getSchema(text, intl) {
  const lcText = text.toLowerCase();
  return {
    id: 'explicit-remove-form',
    properties: [
      {
        id: 'confirm',
        label: { ...messages.intro, values: { text, lcText } },
        type: 'text',
        attributes: { className: 'w-50' },
        schema: string().test(
          'Must be confirmtext',
          () => intl.formatMessage(messages.feedback, { text, lcText }),
          (val) => val === lcText.toLowerCase(),
        ),
      },
    ],
  };
}

export default getSchema;
